import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState(null);

  const loadSettings = useCallback(async () => {
    const { data } = await api.get("/settings");
    setSettings(data);
  }, []);

  useEffect(() => {
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  useEffect(() => {
    if (user) {
      loadSettings().catch(() => {});
    }
  }, [user, loadSettings]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setSettings(null);
  };

  return (
    <AppContext.Provider value={{ user, setUser, settings, setSettings, loadSettings, logout }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
